import * as React from 'react';
import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';
export var VoiceOfCustomer = function () {
  return React.createElement("div", {
    "data-testid": "voice-of-the-customer"
  }, React.createElement(VoiceOfTheCustomer, {
    skipSsr: true,
    inputs: {}
  }));
};